module.exports = __webpack_public_path__ + "assets/b123.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b123.png
// module id = 596
// module chunks = 0